<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>随机卡配置</span>
          <div style="margin-left: 50px;margin-top: 20px;">
            <el-button v-permisaction="['config:randCard:add']" size="mini" type="primary" @click="dialogVisible = true">添加等级</el-button>
            <clear-cache-apply />
            <sync-data />
          </div>

          <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="500px;"
          >
            <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
              <el-form-item label="等级">
                <el-input v-model.number="levelFormData.min_level" style="width: 100px;" placeholder="最小值" />
              </el-form-item>
              <el-form-item label="-">
                <el-input v-model.number="levelFormData.max_level" style="width: 100px;" placeholder="最大值" />
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="addLevel">保存</el-button>
            </span>
          </el-dialog>

          <el-dialog
            title="提示"
            :visible.sync="dialogVisibleScoreEvent"
            width="500px"
          >
            <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
              <el-form-item label="选择分组">
                <el-select v-model="scoreFormData.group" style="width: 150px" multiple placeholder="请选择">
                  <el-option
                    v-for="item in groups"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisibleScoreEvent = false">取 消</el-button>
              <el-button type="primary" @click="addGroup()">保存</el-button>
            </span>
          </el-dialog>

        </div>

        <el-tabs v-model="levelActiveName" tab-position="left" style="height: 100%;" @tab-click="handleClick">
          <el-tab-pane v-for="(tabItem,index) in tabPane" :key="index" :name="tabItem.label" :label="'Lv:'+tabItem.label">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <!--------  等级配置----->
              <el-form :inline="true">
                <el-form-item label="等级">
                  <el-input v-model.number="tabItem.min_level" style="width: 100px;" placeholder="最小值" @change="(v)=>{return levelChange(v, 1,tabItem.bak_min_level, tabItem.bak_max_level)}" />
                </el-form-item>
                <el-form-item label="-">
                  <el-input v-model.number="tabItem.max_level" style="width: 100px;" placeholder="最大值" @change="(v)=>{return levelChange(v, 0,tabItem.bak_min_level, tabItem.bak_max_level)}" />
                </el-form-item>
              </el-form>
              <!--------  等级配置----->
              <el-button style="margin: 10px 0 10px 0" @click="addScoreEvent(tabItem.label)">+分组</el-button>
              <el-form>
                <div v-if="formData.hasOwnProperty(tabItem.label)">
                  <el-row v-for="(scoreItem, scoreIndex) in formData[tabItem.label]" :key="scoreIndex">
                    <el-card class="box-card" style="margin-top: 10px">
                      <div slot="header" class="clearfix" style="height: 60px;">
                        <el-form :inline="true">
                          <el-select v-model="scoreItem.group_bak" multiple placeholder="请选择" style="width: 500px;" @change="(v)=>{return groupChange(v,tabItem.label,scoreItem.group_name)}">
                            <el-option
                              v-for="item in groups"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            />
                          </el-select>
                        </el-form>
                      </div>
                      <el-form>
                        <el-row v-for="(item, score_index) in scoreItem.data" :key="score_index">
                          <el-form-item label="事件标题">
                            <el-input v-model.trim="item.lang_key" style="width: 400px;" placeholder="事件标题" />
                          </el-form-item>
                          <el-form-item label="说明文案" prop="lang_content_key">
                            <el-input v-model.trim="item.lang_content_key" type="textarea" style="width: 400px;" placeholder="说明文案" />
                          </el-form-item>
                          <el-form-item label="触发icon" prop="icon_id">
                            <el-input v-model.number="item.icon_id" style="width: 400px;" placeholder="触发icon" />
                          </el-form-item>
                          <el-form-item prop="config">
                            <el-row v-for="(c,ci) in item.config" :key="ci">
                              <el-form :inline="true">
                                <el-form-item label="类型" style="margin-top: 10px;">
                                  <el-select v-model.number="c.type" disabled="disabled" placeholder="请选择">
                                    <el-option
                                      v-for="(item, index) in eventType"
                                      :key="index"
                                      :label="item.label"
                                      :value="item.value"
                                    />
                                  </el-select>
                                </el-form-item>
                                <el-form-item label="权重" style="margin-top: 10px;">
                                  <el-input v-model.number="c.v" style="width: 130px;" placeholder="权重" />
                                </el-form-item>
                                <el-form-item style="margin-top: 10px;">
                                  <el-button type="primary" @click="addEvent1(tabItem.label,scoreItem.group_name ,score_index, ci)">添加具体事件</el-button>
                                </el-form-item>
                              </el-form>
                              <el-form-item prop="config">
                                <el-card style="margin-left: 40px;margin-top: 5px">
                                  <el-row v-for="(conf,i) in c.config" :key="i">
                                    <el-form :inline="true">
                                      <el-form-item v-if="conf.type !== 3" label="排序" style="margin-top: 10px;">
                                        <el-input v-model.number="conf.sort" style="width: 130px;" placeholder="排序" />
                                      </el-form-item>
                                      <el-form-item label="事件" style="margin-top: 10px;">
                                        <el-select v-model.number="conf.type" placeholder="请选择" @change="(v)=>smallChangeEvent(tabItem.label,scoreItem.group_name ,index, v, i)">
                                          <el-option
                                            v-for="(item, index) in smallEventType"
                                            :key="index"
                                            :label="item.label"
                                            :value="item.value"
                                          />
                                        </el-select>
                                      </el-form-item>
                                      <el-form-item label="权重" style="margin-top: 10px;">
                                        <el-input v-model.number="conf.v" style="width: 130px;" placeholder="权重" />
                                      </el-form-item>
                                      <el-form-item v-if="conf.type === 1" label="大小" style="margin-top: 10px;">
                                        <el-select v-model.number="conf.dimension" placeholder="请选择" @change="(v)=>smallChangeEvent(tabItem.label,scoreItem.group_name ,index, v, i)">
                                          <el-option
                                            v-for="(item, index) in dimensionType"
                                            :key="index"
                                            :label="item.label"
                                            :value="item.value"
                                          />
                                        </el-select>
                                      </el-form-item>
                                      <span v-if="conf.type === 3">
                                        <el-form-item label="类型" style="margin-top: 10px;">
                                          <el-select v-model="conf.eventType" placeholder="请选择类型">
                                            <el-option v-for="(item, index) in chessBoardType" :key="index" :label="item.title" :value="item.id" />
                                          </el-select>
                                        </el-form-item>
                                      </span>
                                      <el-form-item style="margin-top: 10px">
                                        <el-button type="danger" @click="delEvent1(tabItem.label,scoreItem.group_name ,score_index, ci, i)">删除</el-button>
                                      </el-form-item>
                                    </el-form>
                                    <el-card v-if="conf.type === 1" class="box-card" style="margin-left: 40px;margin-top: 10px">
                                      <el-row v-for="(pp,pi) in conf.reward" :key="pi">
                                        <div v-if="conf.type === 1">
                                          <el-form :inline="true">
                                            <el-form-item label="道具" style="margin-top: 10px;">
                                              <el-select v-model.number="pp.propsId" :prop="'formData.config' +index +'.reward.'+pi +'.propsId'" style="width: 130px;" placeholder="请选择" @change="v=>propChange(v,tabItem.label,scoreItem.group_name ,score_index, ci, i, pi)">
                                                <el-option
                                                  v-for="(item, index) in rewardType"
                                                  :key="index"
                                                  :label="item.label"
                                                  :value="item.value"
                                                />
                                              </el-select>
                                            </el-form-item>
                                            <el-form-item label="奖品数量" style="margin-top: 10px;">
                                              <el-input v-model.number="pp.num" :readonly="skinId.includes(pp.propsId)" style="width: 130px;" :prop="'formData.config' +index +'.reward.'+pi +'.num'" placeholder="奖品数量" />
                                            </el-form-item>
                                            <el-form-item style="margin-top: 10px;" label="金币取值">
                                              <el-select v-model.number="pp.rtype" :disabled="pp.propsId !== 14" placeholder="请选择" style="width: 120px" :prop="'formData.config' +index +'.reward.'+pi +'.rtype'">
                                                <el-option
                                                  v-for="item in selectType"
                                                  :key="item.id"
                                                  :label="item.title"
                                                  :value="item.id"
                                                />
                                              </el-select>
                                            </el-form-item>
                                            <el-form-item v-if="skinId.includes(pp.propsId)" style="margin-top: 10px;" label="选择皮肤">
                                              <el-select v-if="pp.propsId === 62" v-model.number="pp.skin" placeholder="请选择" style="width: 120px" :prop="'formData.config' +index +'.reward.'+pi +'.skin'">
                                                <el-option
                                                  v-for="item in chessId"
                                                  :key="item.value"
                                                  :label="item.label"
                                                  :value="item.value"
                                                />
                                              </el-select>

                                              <el-select v-if="pp.propsId === 19" v-model.number="pp.skin" placeholder="请选择" style="width: 120px" :prop="'formData.config' +index +'.reward.'+pi +'.skin'">
                                                <el-option
                                                  v-for="item in areaId"
                                                  :key="item.value"
                                                  :label="item.label"
                                                  :value="item.value"
                                                />
                                              </el-select>

                                              <el-select v-if="pp.propsId === 67" v-model.number="pp.skin" placeholder="请选择" style="width: 120px" :prop="'formData.config' +index +'.reward.'+pi +'.skin'">
                                                <el-option
                                                  v-for="item in shield"
                                                  :key="item.value"
                                                  :label="item.label"
                                                  :value="item.value"
                                                />
                                              </el-select>

                                              <el-select v-if="pp.propsId === 68" v-model.number="pp.skin" placeholder="请选择" style="width: 120px" :prop="'formData.config' +index +'.reward.'+pi +'.skin'">
                                                <el-option
                                                  v-for="item in sieve"
                                                  :key="item.value"
                                                  :label="item.label"
                                                  :value="item.value"
                                                />
                                              </el-select>
                                            </el-form-item>
                                            <el-form-item style="margin-top: 10px">
                                              <el-button type="danger" @click="removeReward(tabItem.label,scoreItem.group_name ,score_index, ci, i, pi)">删除</el-button>
                                            </el-form-item>
                                          </el-form>
                                        </div>

                                        <div v-if="conf.type === 2">
                                          <p>优惠券</p>
                                        </div>

                                      </el-row>
                                      <el-form-item style="margin-top: 10px">
                                        <el-button type="primary" @click="addEventReward(tabItem.label,scoreItem.group_name , score_index, ci, i)">+</el-button>
                                      </el-form-item>
                                    </el-card>
                                    <el-card v-if="conf.type === 4" class="box-card" style="margin-left: 40px;margin-top: 10px">
                                      <el-row v-for="(pp,pi) in conf.game" :key="pi">
                                        <div v-if="conf.type === 4">
                                          <el-form :inline="true">
                                            <el-form-item label="小游戏" style="margin-top: 10px;">
                                              <el-select v-model.number="pp.Id" style="width: 130px;" placeholder="请选择">
                                                <el-option
                                                  v-for="(item, index) in gameType"
                                                  :key="index"
                                                  :label="item.label"
                                                  :value="item.value"
                                                />
                                              </el-select>
                                            </el-form-item>
                                            <el-form-item label="权重" style="margin-top: 10px;">
                                              <el-input v-model.number="pp.v" style="width: 130px;" placeholder="权重" />
                                            </el-form-item>
                                            <el-form-item style="margin-top: 10px">
                                              <el-button type="danger" @click="removeReward(tabItem.label,scoreItem.group_name ,score_index, ci, i, pi)">删除</el-button>
                                            </el-form-item>
                                          </el-form>
                                        </div>
                                      </el-row>
                                      <el-form-item style="margin-top: 10px">
                                        <el-button type="primary" @click="addEventReward(tabItem.label,scoreItem.group_name , score_index, ci, i,4)">+</el-button>
                                      </el-form-item>
                                    </el-card>
                                  </el-row>
                                </el-card>
                              </el-form-item>
                            </el-row>
                          </el-form-item>
                          <el-form-item>
                            <el-button v-permisaction="['config:randCard:del']" type="danger" @click="delEvent(tabItem.label,scoreItem.group_name ,item.id)">删除</el-button>
                            <el-button v-permisaction="['config:randCard:add']" type="primary" @click="onSubmit()">保存</el-button>

                          </el-form-item>
                        </el-row>
                        <el-button v-if="scoreItem.data.length <= 0" type="primary" @click="addEvent(tabItem.label,scoreItem.group_name)">+</el-button>
                      </el-form>
                    </el-card>
                  </el-row>
                </div>
              </el-form>
            </el-tabs>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import Vue from 'vue'
import { getChessBoardType, getRewardType } from '@/api/config/slot'
import { delFirstCfg, updateRandCardCfg, getRandCardCfgList, getSmallGameType } from '@/api/config/rand-card-cfg'
import { getAnimalAllList, getShieldsAllList, getSieveAllList } from '@/api/config/area-cfg'
import { getUserTypeAllList } from '@/api/config/user-group-cfg'
import { getChestCfgAll } from '@/api/config/chest-skin-cfg'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'
export default {
  name: 'RandCard',
  components: { SyncData, ClearCacheApply },
  data() {
    return {
      gameType: [],
      tabPane: [],
      visibleArr: {},
      dimensionType: [
        { label: '大', value: 1 },
        { label: '中', value: 2 },
        { label: '小', value: 3 }
      ],
      selectType: [
        {
          'id': 1,
          'title': '只取数量'
        },
        {
          'id': 2,
          'title': '等级取值'
        }
      ],
      rewardType: [],
      chessBoardType: [],
      groups: [
        { label: '默认分组', value: 0 }
        // { label: '免费玩家', value: 1 },
        // { label: '付费玩家', value: 2 }
      ],

      eventType: [
        {
          'value': 'common',
          'label': '常规随机卡事件'
        },
        {
          'value': 'special',
          'label': '特殊随机卡事件'
        }
        // {
        //   'value': 3,
        //   'label': '活动随机卡事件'
        // }
      ],
      smallEventType: [
        {
          'value': 1,
          'label': '奖励事件'
        },
        // {
        //   'value': 2,
        //   'label': '活动事件'
        // },
        {
          'value': 3,
          'label': '指定事件'
        },
        {
          'value': 4,
          'label': '小游戏事件'
        }
      ],
      appearType: [
        { 'label': '否', value: 0 },
        { 'label': '是', value: 1 }
      ],
      dialogVisible: false,
      dialogVisibleScoreEvent: false,
      levelFormData: {
        min_level: 0,
        max_level: 0
      },
      scoreFormData: {
        group: [],
        group_name: '',
        group_bak: [],
        level_name: '',
        event_name: ''
      },
      activeName: 'first',
      levelActiveName: '',
      copyFormData: {},
      formData: {},
      skinId: [62, 19, 67, 68],
      chessId: [],
      areaId: [],
      shield: [],
      sieve: []
    }
  },
  created() {
    this.getShieldsId()
    this.getSieveId()
    this.getGameType()
    this.getGroup()
    this.getChessId()
    this.getAreaId()
    this.getTables()
    this.getRewardTypeData()
    this.getChessBoardType()
  },
  methods: {
    onSubmit(noTips = false) {
      const data = JSON.stringify(this.formData)
      console.log(data)
      const formData = this.formData
      let levelIndex = 0
      const postFormDataCondition = {}
      let _postData = []
      const postFormData = {}
      for (const i in formData) {
        this.levelActiveName = i
        let groupIndex = 0
        levelIndex++
        const scoreData = formData[i]
        const [minLevel, maxLevel] = i.split('-')
        for (const i2 in scoreData) {
          groupIndex++
          const scoreItem = scoreData[i2]
          console.log('activeName', this.activeName)
          const key = levelIndex + '-' + groupIndex
          if (parseInt(minLevel) > parseInt(maxLevel)) {
            this.msgError('最低等级不能大于最高等级')
            return
          }

          const _formdata = scoreItem.data[0]
          if (_formdata.lang_key === '') {
            this.msgError('事件标题不能为空')
            return
          }
          _formdata.lang_key = _formdata.lang_key.replace(/\s/g, '')
          if (_formdata.icon === '') {
            this.msgError('触发ICON不能为空')
            return
          }

          for (const i in _formdata.config) {
            const _config = _formdata.config[i]
            for (const k in _config.config) {
              const c = _config.config[k]
              for (const j in c.reward) {
                if (c.reward[j].propsId === 65) {
                  _formdata.config[i].config[k].reward[j].num *= 10000
                }
              }
            }
          }

          // for (const i in _formdata.config.special.config) {
          //   const _config = _formdata.config.special.config[i]
          //   for (const k in _config.reward) {
          //     const reward = _config.reward[k]
          //     if (reward.propsId === 65) {
          //       _formdata.config.special.config[i].reward[k].num *= 10000
          //     }
          //   }
          // }
          // if (_formdata.v === '') {
          //   this.msgError('权重不能为空')
          //   return
          // }

          // if (_formdata.type <= 0) {
          //   this.msgError('请选择事件类型')
          //   return
          // }

          if (_formdata.config.length <= 0) {
            this.msgError('至少增加一个具体事件')
            return
          }

          // if (scoreItem.data[0].length < 1) {
          //   continue
          // }

          postFormDataCondition[key] = {
            start: parseInt(minLevel),
            end: parseInt(maxLevel),
            groups: scoreItem.group
          }

          postFormData[key] = {
            'level': minLevel + '-' + maxLevel,
            'data': scoreItem.data
          }

          const _data = scoreItem.data[0]
          _data.condition = key
          _postData.push(_data)
        }
      }

      for (const k in _postData) {
        const _data = _postData[k]
        console.log(_data)
        for (const kk in _data) {
          if (kk === 'config') {
            const _config = _data[kk]
            console.log('_config', _config)
            _postData[k][kk] = {}
            _postData[k][kk] = {
              common: {
                config: _config[0].config,
                v: _config[0].v
              },
              special: {
                config: _config[1].config,
                v: _config[1].v
              }
            }
          }
        }
      }
      // console.log(_postData)
      const postCondition = JSON.stringify(postFormDataCondition)
      _postData = JSON.stringify(_postData)
      console.log('postCondition', postCondition)
      console.log('_postData', _postData)
      updateRandCardCfg({ name: postCondition, data: _postData }).then(res => {
        if (res.code === 200) {
          if (!noTips) {
            this.msgSuccess(res.msg)
          }
          this.getTables(this.levelActiveName)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables(actName) {
      console.log('actName', actName)
      getRandCardCfgList().then(res => {
        const data = res.data.data
        console.log(data)
        // const tab = {}
        const cond = res.data.cond
        for (const i in cond) {
          const val = cond[i]
          const levelName = val.start + '-' + val.end
          const scoreName = val.groups.join('-')

          // 初始化弹窗
          if (!Object.prototype.hasOwnProperty.call(this.visibleArr, levelName)) {
            this.$set(this.visibleArr, levelName, {})
          }

          // eslint-disable-next-line no-unused-vars
          if (!Object.prototype.hasOwnProperty.call(this.formData, levelName)) {
            this.$set(this.formData, levelName, {})
          }

          // if (!Object.prototype.hasOwnProperty.call(this.formData[levelName][scoreName], 'data')) {
          //   this.$set(this.formData[levelName][scoreName], 'data', [])
          // }

          this.$set(this.formData[levelName], scoreName, {
            'group': val.groups,
            'group_name': scoreName,
            'group_bak': val.groups,
            data: []
          })

          for (const ii in data) {
            const _event = data[ii]
            if (_event.condition === i) {
              const _config = _event.config
              for (const j in _config.common.config) {
                const _c = _config.common.config[j]
                for (const r in _c.reward) {
                  if (_c.reward[r].propsId === 65) {
                    _event.config.common.config[j].reward[r].num /= 10000
                  }
                }
              }

              for (const j in _config.special.config) {
                const _c = _config.special.config[j]
                for (const r in _c.reward) {
                  if (_c.reward[r].propsId === 65) {
                    _event.config.special.config[j].reward[r].num /= 10000
                  }
                }
              }
              _event.config = [{
                type: 'common',
                config: _config.common.config,
                v: _config.common.v
              }, {
                type: 'special',
                config: _config.special.config,
                v: _config.special.v
              }]
              console.log('_event', _event)
              this.$set(this.formData[levelName][scoreName], 'data', [_event])
            }
          }

          // 等级
          let findIndex = -1
          this.tabPane.forEach((item, index) => {
            if (item.label === levelName) {
              findIndex = index
            }
          })

          if (findIndex === -1) {
            this.tabPane.push({
              label: levelName,
              min_level: val.start,
              max_level: val.end,
              bak_min_level: val.start,
              bak_max_level: val.end,
              add: true
            })
          }
          console.log('actName', actName)
          if (actName) {
            this.levelActiveName = actName
          } else {
            this.levelActiveName = levelName
          }
        }
      })
    },
    levelChange(newVal, isMin, bakMin, bakMax) {
      newVal = parseInt(newVal)
      const oldLevelName = bakMin + '-' + bakMax
      console.log('old', oldLevelName)
      let newLevelName = ''
      if (isMin) {
        newLevelName = newVal + '-' + bakMax
      } else {
        newLevelName = bakMin + '-' + newVal
      }

      if (Object.prototype.hasOwnProperty.call(this.formData, newLevelName)) {
        // if (this.formData.hasOwnPropert(newLevelName)) {
        this.msgError('修改失败')
        return
      }

      const oldData = this.formData[oldLevelName]
      Vue.delete(this.formData, oldLevelName)
      // eslint-disable-next-line no-undef
      this.$set(this.formData, newLevelName, oldData)
      // 修改弹窗
      const oldVisle = this.visibleArr[oldLevelName]
      Vue.delete(this.visibleArr, oldLevelName)
      this.$set(this.visibleArr, newLevelName, oldVisle)
      let fileIndex = -1
      this.tabPane.filter((res, index) => {
        if (res.label === oldLevelName) {
          // eslint-disable-next-line no-unused-vars
          fileIndex = index
        }
      })
      if (fileIndex > -1) {
        const oldTab = this.tabPane[fileIndex]
        oldTab['label'] = newLevelName
        if (isMin) {
          oldTab['bak_min_level'] = newVal
          oldTab['min_level'] = newVal
        } else {
          oldTab['bak_max_level'] = newVal
          oldTab['max_level'] = newVal
        }
        this.tabPane[fileIndex] = oldTab
      }
      this.levelActiveName = newLevelName
    },
    addEvent1(levelName, scoreName, index, ci) {
      this.formData[levelName][scoreName].data[index].config[ci].config.push({
        type: 1,
        sort: 0,
        reward: [{
          propsId: 1,
          skin: 0,
          num: 0,
          rtype: 2
        }],
        game: [],
        eventType: 0,
        dimension: 0,
        v: 0
      })
      console.log(this.formData[levelName][scoreName].data[index])
    },
    delEvent1(levelName, scoreName, index, ci, i) {
      // console.log(this.formData[levelName][scoreName].data[index].config[ci].config[i])
      this.formData[levelName][scoreName].data[index].config[ci].config = this.formData[levelName][scoreName].data[index].config[ci].config.filter((item, key) => {
        return i !== key
      })
    },
    addEventReward(levelName, scoreName, index, ci, i, type) {
      let propsId = 14
      if (this.formData[levelName][scoreName].data[index].config[ci].config[i].type === 3) {
        propsId = 1
        if (this.formData[levelName][scoreName].data[index].config[ci].config[i].reward.length >= 1) {
          return
        }
      }
      if (this.formData[levelName][scoreName].data[index].config[ci].config[i].type === 4) {
        if (!Object.prototype.hasOwnProperty.call(this.formData[levelName][scoreName].data[index].config[ci].config[i], 'game')) {
          this.$set(this.formData[levelName][scoreName].data[index].config[ci].config[i], 'game', [])
          delete this.formData[levelName][scoreName].data[index].config[ci].config[i].reward
        }
        this.formData[levelName][scoreName].data[index].config[ci].config[i].game.push({
          Id: 1,
          v: 0
        })
      } else {
        if (!Object.prototype.hasOwnProperty.call(this.formData[levelName][scoreName].data[index].config[ci].config[i], 'reward')) {
          this.$set(this.formData[levelName][scoreName].data[index].config[ci].config[i], 'reward', [])
          delete this.formData[levelName][scoreName].data[index].config[ci].config[i].game
        }
        this.formData[levelName][scoreName].data[index].config[ci].config[i].reward.push({
          propsId: propsId,
          skin: 0,
          num: 0,
          rtype: 2
        })
      }
    },
    addEvent(levelName, scoreName) {
      if (this.formData[levelName][scoreName].data.length > 0) {
        this.msgError('已达上限')
        return
      }
      this.formData[levelName][scoreName].data.push({
        'id': 0,
        'lang_key': '',
        'lang_content_key': '',
        'icon_id': '',
        'type': 1,
        'v': 0,
        'config': [
          {
            type: 'common',
            config: [{
              type: 1,
              reward: [{
                propsId: 1,
                skin: 0,
                num: 0,
                rtype: 2
              }],
              game: [],
              eventType: 0,
              v: 0 }
            ],
            v: 0
          },
          {
            type: 'special',
            config: [{
              type: 1,
              reward: [{
                propsId: 1,
                skin: 0,
                num: 0,
                rtype: 2
              }],
              game: [],
              eventType: 0,
              v: 0 }
            ],
            v: 0
          }
        ]
      })
      // this.visibleArr[levelName][scoreName].push({ visible: false })
    },
    delEvent(levelName, scoreName, id) {
      console.log(this.formData[levelName][scoreName])
      if (id > 0) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delFirstCfg({ id: id }).then(res => {
            if (res.code === 200) {
              this.formData[levelName][scoreName].data = []
              // this.msgSuccess(res.msg)
              this.onSubmit(true)
              this.getTables()
            } else {
              // this.msgError(res.msg)
            }
          })
        })
      }
    },
    addScoreEvent(levelName) {
      this.scoreFormData.max_score = 0
      this.scoreFormData.min_score = 0
      this.scoreFormData.level_name = levelName
      this.dialogVisibleScoreEvent = true
    },
    addGroup() {
      const score = this.scoreFormData
      if (score.group.length <= 0) {
        this.msgError('请选择分组')
        return
      }
      this.dialogVisibleScoreEvent = false
      const bakGroup = score.group
      const scoreTag = score.group.join('-')
      console.log(this.formData[score.level_name])
      // eslint-disable-next-line no-prototype-builtins
      if (!Object.prototype.hasOwnProperty.call(this.formData[score.level_name], scoreTag)) {
        this.$set(this.formData[score.level_name], scoreTag, {
          'group': bakGroup,
          'group_name': scoreTag,
          'group_bak': bakGroup,
          'data': []
        })

        this.$set(this.visibleArr[score.level_name], scoreTag, [])
      }

      if (this.formData[score.level_name][scoreTag].data.length > 0) {
        this.msgError('当前分组元素已达上限')
        return
      }

      // 弹窗事件
      this.visibleArr[score.level_name][scoreTag].push({ visible: false })
      // 添加第一个元素
      this.formData[score.level_name][scoreTag].data.push({
        'id': 0,
        'type': 1,
        'lang_key': '',
        'lang_content_key': '',
        'icon_id': '',
        'v': 0,
        'config': [
          {
            type: 'common',
            config: [{
              type: 1,
              reward: [{
                propsId: 1,
                skin: 0,
                num: 0,
                rtype: 2
              }],
              eventType: 0,
              v: 0 }
            ],
            v: 0
          },
          {
            type: 'special',
            config: [{
              type: 1,
              reward: [{
                propsId: 1,
                skin: 0,
                num: 0,
                rtype: 2
              }],
              eventType: 0,
              v: 0 }
            ],
            v: 0
          }
        ]
      })

      this.activeName = score.level_name
      this.scoreFormData.group = []
      this.scoreFormData.group_bak = []
      this.scoreFormData.group_name = ''
      // console.log(this.formData)
    },
    addLevel() {
      console.log('添加等级')
      this.dialogVisible = false
      if (this.levelFormData.min_level > this.levelFormData.max_level) {
        this.msgError('最低等级不能大于最大等级')
        return
      }
      const levelName = this.levelFormData.min_level + '-' + this.levelFormData.max_level
      if (Object.prototype.hasOwnProperty.call(this.formData, levelName)) {
        this.msgError('等级已经存在')
        return
      }

      this.tabPane.push({
        'label': this.levelFormData.min_level + '-' + this.levelFormData.max_level,
        'min_level': this.levelFormData.min_level,
        'max_level': this.levelFormData.max_level,
        'bak_min_level': this.levelFormData.min_level,
        'bak_max_level': this.levelFormData.max_level,
        add: true
      })
      this.levelActiveName = levelName
      // 初始化等级
      this.$set(this.formData, levelName, {})
      // 初始化弹窗
      this.$set(this.visibleArr, levelName, {})
      console.log(this.formData)
    },
    handleClick(tab, event) {
      console.log(tab.name)
      this.activeName = tab.name
    },
    scoreChange(newVal, isMin, levelName, minBak, maxBak) {
      console.log('scoreChange', newVal)
      const oldScoreName = minBak + '-' + maxBak
      let newScoreName = newVal + '-' + maxBak
      if (!isMin) {
        newScoreName = minBak + '-' + newVal
      }
      const oldData = this.formData[levelName][oldScoreName]

      if (isMin) {
        oldData.min_score = newVal
        oldData.min_score_bak = newVal
      } else {
        oldData.max_score = newVal
        oldData.max_score_bak = newVal
      }

      // // 删除旧积分
      Vue.delete(this.formData[levelName], oldScoreName)
      this.$set(this.formData[levelName], newScoreName, oldData)
      console.log(this.formData[levelName])
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    addReward(levelName, groupName, index) {
      console.log(this.formData[levelName])
      if (this.formData[levelName][groupName].data[index].reward.length >= 10) {
        this.msgError('已达上限')
        return
      }
      const len = this.formData[levelName][groupName].data[index].reward.length + 1
      this.formData[levelName][groupName].data[index].reward.push(
        { id: len,
          prize:
            { propsId: 1, num: 1, skin: 1, rtype: 1 }, v: 1
        }
      )
    }, delReward(levelName, groupName, index, i) {
      this.formData[levelName][groupName].data[index].reward = this.formData[levelName][groupName].data[index].reward.filter((item, key) => {
        return key !== i
      })
    },
    groupChange(v, levelName, oldGroupName) {
      v = v.sort()
      const newGroupName = v.join('-')
      const oldData = this.formData[levelName][oldGroupName]
      this.$delete(this.formData[levelName], oldGroupName)
      oldData.group = v
      oldData.group_bak = v
      oldData.group_name = newGroupName
      console.log('newGroupName', newGroupName)
      if (Object.prototype.hasOwnProperty.call(this.formData[levelName], newGroupName)) {
        this.msgError('当前分组已经存在')
        this.getTables(this.activeName)
        return
      }
      this.$set(this.formData[levelName], newGroupName, oldData)
      // 修改弹窗元素
      const oldVisible = this.visibleArr[levelName][oldGroupName]
      this.$delete(this.visibleArr[levelName], oldGroupName)
      this.$set(this.visibleArr[levelName], newGroupName, oldVisible)
    },
    getChessBoardType() {
      getChessBoardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.chessBoardType.push({ 'title': res.data[i], 'id': parseInt(i) })
          }
        }
      })
    },
    smallChangeEvent(levelName, groupName, index, v, i) {
      console.log('smallChangeEvent', v)
      if (v === 3) {
        this.formData[levelName][groupName].data[index].config[i].eventType = 1
        this.formData[levelName][groupName].data[index].config[i].reward = []
      }

      if (v === 1) {
        this.formData[levelName][groupName].data[index].config[i].eventType = 0
        this.formData[levelName][groupName].data[index].config[i].reward = [{
          propsId: 1,
          skin: 0,
          num: 0,
          rtype: 2
        }]
      }
    },
    removeReward(levelName, scoreName, index, ci, i, pi) {
      if (this.formData[levelName][scoreName].data[index].config[ci].config[i].type === 4) {
        this.formData[levelName][scoreName].data[index].config[ci].config[i].game = this.formData[levelName][scoreName].data[index].config[ci].config[i].game.filter((item, key) => {
          return pi !== key
        })
      } else {
        this.formData[levelName][scoreName].data[index].config[ci].config[i].reward = this.formData[levelName][scoreName].data[index].config[ci].config[i].reward.filter((item, key) => {
          return pi !== key
        })
      }
    },
    getAreaId() {
      getChestCfgAll().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.areaId.push({ 'label': res.data[i].name, 'value': parseInt(res.data[i].id) })
          }
        }
      })
    },
    getChessId() {
      getAnimalAllList().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.chessId.push({ 'label': res.data[i].lang_key, 'value': parseInt(res.data[i].id) })
          }
        }
      })
    },
    getShieldsId() {
      getShieldsAllList().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.shield.push({ 'label': res.data[i].lang_key, 'value': parseInt(res.data[i].id) })
          }
        }
      })
    },
    getSieveId() {
      getSieveAllList().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.sieve.push({ 'label': res.data[i].lang_key, 'value': parseInt(res.data[i].id) })
          }
        }
      })
    },
    propChange(v, levelName, scoreName, index, ci, i, pi) {
      const record = this.formData[levelName][scoreName].data[index].config[ci].config[i].reward[pi]
      const typ = parseInt(v)
      record.num = 1
      switch (typ) {
        case 64:
          record.skin = this.chessId[0].value
          break

        case 19:
          record.skin = this.areaId[0].value
          break
        default:
          record.skin = 0
      }
    },
    getGroup() {
      getUserTypeAllList().then(res => {
        if (res.code === 200) {
          res.data.forEach(res => {
            this.groups.push({ label: res.name, value: res.groupId })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getGameType() {
      this.gameType = []
      getSmallGameType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.gameType.push({ label: res.data[i], value: parseInt(i) })
          }
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
